
const app = Vue.createApp({
  data: () => ({
    categories: null,
    items: null,
    selectedCategory: null,
    inventory: []
  }),
  methods: {
    init() {
      this.loadCategories();
      this.loadItems();
      this.restoreLocalStorage();
    },
    _generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },
    _updateLocalStorage() {
      localStorage.setItem('fs-inventory-list', JSON.stringify(this.inventory));
    },

    increaseItem(item) {
      const found = this.items.find(i => i.name === item.name);
      if (found) found.quantity += 1;
      
      this.updateInventoryItem(item);
    },

    decreaseItem(item) {
      const found = this.items.find(i => i.name === item.name);
      if (found && found.quantity > 0) {
        found.quantity -= 1;
      }

      this.updateInventoryItem(item);
    },

    updateInventoryItem(item) {
      const found = this.inventory.find(i => i.name === item.name);

      if (found) {
        console.log("item already in inventory: ", { found });
        
        if (item.quantity < 1) {
          // Remove item if quantity is less than 1
          const index = this.inventory.findIndex(i => i.name === item.name);
          if (index !== -1) {
            this.inventory.splice(index, 1); // Reactively remove item
          }
        } else {
          found.quantity = item.quantity;
        }
      } else {
        // Add the new item if not found
        this.inventory.push({ ...item }); // Ensure reactivity by adding a new object
      }

      this._updateLocalStorage();
    },
    remove(item){
      // update inventory
      this.inventory = this.inventory.filter(i => i.name !== item.name);

      // update initial item
      const found = this.items.find(i => i.name === item.name);
      found.quantity = 0;

      this._updateLocalStorage();
    },
    loadCategories() {
      const categories = JSON.parse(document.querySelector('#categoriesData').innerHTML);
      this.categories = categories;
    },
    loadItems() {
      // datasource set from section settings
      const datasource = document.querySelector('#calculator-app').dataset.source;
      const selector = `#itemsData${datasource}`;
      const data = JSON.parse(document.querySelector(selector).innerHTML);
      const orderedItems = data.items.sort((a, b) => {
        if (a.category < b.category) return -1;
        if (a.category > b.category) return 1;
        return 0;
      });
      this.items = orderedItems.map(i => {
        return {
          ...i,
          quantity: 0 // append qty for selection purposes
        }
      })
    },
    selectCategory(activeIndex) {
      if (this.categories && this.categories.length ) {
        this.selectedCategory = this.categories[activeIndex];
      }
      console.log({ categoryIndex: activeIndex, selected: this.selectedCategory })
    },
    restoreLocalStorage(){
      const storedList = localStorage.getItem('fs-inventory-list');
      const parsedList = JSON.parse(storedList);
      if (!parsedList) return;

      // only load store list if available
      this.inventory = [ ...parsedList ];

      // set initial items state
      this.inventory.forEach(item => {
        const found = this.items.find(i => i.name === item.name);
        if (found) {
          found.quantity = item.quantity;
        }
      })
    }

  },
  // computed: {},
  mounted() {
    this.init();
  }
});

// Tell Vue that address-autocomplete is a native custom element, not a Vue component
app.config.compilerOptions.isCustomElement = (tag) => tag === 'address-autocomplete';

app.component('categories-slider', {
  template: '#categories-slider-template',
  data: () => ({
    swiper: null
  }),
  props: {
    categories: {
      type: Array,
      required: false
    }
  },
  emits: ['category-selected', 'slide-changed'],
  methods: {
    init() {
      this.swiper = new Swiper('.swiper', {
        slidesPerView: 3,
        spaceBetween: 0,
        initialSlide: 0,
        autoHeigth: false,
        centeredSlides: false,
        centeredSlidesBounds: false,
        direction: 'horizontal',
        loop: false,
        slideToClickedSlide: true,
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true,
        // },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          // when window width is >= 640px
          768: {
            slidesPerView: 6,
          },
          960: {
            slidesPerView: 8,
          },
          1025: {
            slidesPerView: 10,
          }
        },
        on: {
          init: (e) => {
            this.$emit('slide-changed', e.activeIndex);
          },
          click: (e) => {
            this.swiper.slides.forEach(slide => slide.classList.remove('active'));
            console.log( { e })
            if (e.clickedSlide) {
              e.clickedSlide.classList.add('active');
              this.$emit('slide-changed', e.clickedSlide.dataset.categoryIndex);
            }
          }
        }
      });
      console.log('categories-slider: init');
    },
    select(category) {
      this.$emit('category-selected', category);
    }
  },
  mounted() {
    this.init();
  }
})

app.component('items-list', {
  template: '#items-list-template',
  props: {
    items: {
      type: Array,
      required: false
    },
    category: {
      type: Object
    }
  },
  emits: ['item-increased', 'item-decreased'],
  methods: {
    init() {
      console.log("items-list: init");
    },
    decrease(item) {
      if (item.quantity < 1) return;
      this.$emit('item-decreased', item);
    },
    increase(item) {
      this.$emit('item-increased', item);
    }
  },
  mounted() {
    this.init();
  }
})

app.component('inventory-list', {
  template: '#inventory-list-template',
  data() {
    return {
      title: 'Your Inventory',
      currentVolumeUnit: this.volumeUnit,
      customer: {
        name: '',
        email: '',
        pickupAddress: '',
      },
      units: [
        {
          name: 'cubic centimeters',
          label: 'cm3',
        },
        {
          name: 'cubic meters',
          label: 'm3',
        },
        {
          name: 'liter',
          label: 'L',
        }
      ]
    }
  },
  props: {
    items: {
      type: Array,
      required: false
    },
    volumeUnit: String
  },
  emits: ['remove-item'],
  methods: {
    init() {
      console.log("inventory-list: init")
    },
    getItemVolume(item) {
      // Parse dimensions as floats
      const length = parseFloat(item.length.value) || 0;
      const width = parseFloat(item.width.value) || 0;
      const height = parseFloat(item.height.value) || 0;
      const quantity = parseInt(item.quantity) || 1;
  
      // Calculate volume in cubic centimeters
      const volumeCm3 = (length * width * height) * quantity;
  
      return this.formatVolume(volumeCm3);
    },
    getTotalVolume() {
      const total = this.items.reduce((total, item) => {
        const length = parseFloat(item.length.value) || 0;
        const width = parseFloat(item.width.value) || 0;
        const height = parseFloat(item.height.value) || 0;
        const quantity = parseInt(item.quantity) || 1;
  
        // Calculate volume in cubic centimeters
        const volumeCm3 = (length * width * height) * quantity;
        return total + volumeCm3;
      }, 0);
  
      return this.formatVolume(total);
    },
    getTotalItems() {
      const total = this.items.reduce((total, item) => {
        return total + item.quantity;
      }, 0);
      const label = (total > 1 ? 'items' : 'item');
      return `${total} ${label}`;
    },
    formatVolume(volumeCm3) {
      const unit = this.currentVolumeUnit;
      let volume;
      switch (unit) {
        case 'm3':
          volume = volumeCm3 / 1000000; // Convert cm³ to cubic meters
          break;
        case 'L':
          volume = volumeCm3 / 1000; // Convert cm³ to liters
          break;
        case 'cm³':
        default:
          volume = volumeCm3; // Keep as cm³ for unsupported units
          break;
      }
      return `${volume.toFixed(2)} ${unit}`; // Format the volume with 2 decimal places
    },
    
    remove(item) {
      this.$emit('remove-item', item);
    },
    onKeyUp(item){
      // item.notes = item.notes;
      localStorage.setItem('fs-inventory-list', JSON.stringify(this.items));
    },
    download() {
      const doc = new window.jspdf.jsPDF();
    
      // Ensure autoTable is available on doc
      if (typeof doc.autoTable !== "function") {
        doc.autoTable = window.jspdfAutoTable || window.jspdf?.autoTable;
      }
    
      // Generate a timestamp in the format YYYY-DD-MM
      const date = new Date();
      const formattedDate = `${date.getFullYear()}-${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}`;
    
      // Header block
      const leftMargin = 14;
      doc.setFontSize(18);
      doc.text("Inventory List", leftMargin, 10);
      doc.setFontSize(10);
      doc.text(`Date: ${formattedDate}`, leftMargin, 20);
      doc.text(`Customer: ${this.customer.name}`, leftMargin, 28);
      doc.text(`Email: ${this.customer.email}`, leftMargin, 36);

      let tableStartY = 44;
      if (this.customer.pickupAddress) {
        doc.text(`Pickup address: ${this.customer.pickupAddress}`, leftMargin, 44);
        tableStartY = 52;
      }
    
      const headers = [["Item", "Quantity", "Observation"]];
      const data = this.items.map(item => [
        `${item.name} - ${item.length.value} x ${item.width.value} x ${item.height.value} ${item.height.unit}`,
        item.quantity.toString(),
        item.notes || "-"
      ]);
      const totals = [ `Total Volume: ${ this.getTotalVolume() }`, this.getTotalItems()];
      data.push(totals);
    
      // Generate the table with footer
      doc.autoTable({
        head: headers,
        body: data,
        startY: tableStartY,
        margin: { left: leftMargin, right: 14 },
        theme: 'striped',
        headStyles: { fillColor: [22, 160, 133] },
        didParseCell: (data) => {
          console.log( { data })
          // Apply dark background for the totals row
          if (data.row.index === data.table.body.length - 1) { // Check if it's the last row
            data.cell.styles.fillColor = [34, 34, 34]; // Dark background
            data.cell.styles.textColor = [255, 255, 255]; // White text
          }
        },
        didDrawPage: (data) => {
          // Footer content
          const footerLeft = "www.fsremovals.com.au | Tel: 1300 123 755 | info@fsremovals.com.au";
          const footerRight = "Page " + doc.internal.getNumberOfPages();
    
          const pageSize = doc.internal.pageSize;
          const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
          const margin = data.settings.margin;
    
          // Set font size for footer
          doc.setFontSize(10);
    
          // Calculate x positions for left and right aligned text
          const leftTextWidth = doc.getTextWidth(footerLeft);
          const rightTextWidth = doc.getTextWidth(footerRight);
          const leftX = margin.left; // Left margin
          const rightX = (pageSize.width || pageSize.getWidth()) - margin.right - rightTextWidth; // Right margin
    
          const y = pageHeight - 10; // Position from the bottom
    
          // Add left and right aligned texts
          doc.text(footerLeft, leftX, y);
          doc.text(footerRight, rightX, y);
        },
      });
    
      // Save the PDF with the customer name and timestamp in the filename
      const safeName = this.customer.name.trim().replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-]/g, '');
      doc.save(`FS-inventory-${safeName}-${formattedDate}.pdf`);
    },

    initAutocomplete() {
      this.$el.addEventListener('ac:location:updated', (e) => {
        this.customer.pickupAddress = e.detail.location.formattedAddress;
        this.saveCustomerDetails();
      });
    },

    saveCustomerDetails() {
      localStorage.setItem('fs-customer-details', JSON.stringify(this.customer));
    },

    restoreCustomerDetails() {
      const stored = localStorage.getItem('fs-customer-details');
      if (!stored) return;
      try {
        const details = JSON.parse(stored);
        if (details.name) this.customer.name = details.name;
        if (details.email) this.customer.email = details.email;
        if (details.pickupAddress) this.customer.pickupAddress = details.pickupAddress;
      } catch (e) {
        console.warn('Could not restore customer details from localStorage');
      }
    }
    
  },
  computed: {
    isFormValid() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return !!this.customer.name.trim() && emailRegex.test(this.customer.email.trim());
    }
  },
  mounted() {
    this.restoreCustomerDetails();
    this.$nextTick(() => this.initAutocomplete());
  }
});

app.mount('#calculator-app');